import React from 'react'
import classNames from 'classnames'
import { ExpertProfileHighlightsFragment } from '#src/generated/graphql'
import { DepartmentIcon, ExpertProfileHighlightIcon } from '@deal/components'
import numeral from 'numeral'
import styles from './styles.css'

interface HighlightsProps {
  className?: string
  invertIcons?: boolean
  departmentSlug: string
  highlights: ExpertProfileHighlightsFragment[] | null
  headline: string | null
  totalLeads: number | null
}

const Highlights: React.SFC<HighlightsProps> = ({
  departmentSlug,
  highlights,
  headline,
  totalLeads,
  className,
  invertIcons
}) => {
  if (!highlights) {
    return null
  }

  const iconClass = invertIcons ? styles.invertedIcon : styles.icon

  return (
    <div className={classNames(styles.highlights, className)}>
      {headline && (
        <div className={styles.attribute}>
          <div className={styles.iconWrapper}>
            <DepartmentIcon strokeWidth={2} departmentSlug={departmentSlug} className={iconClass} />
          </div>
          <div className={styles.labels}>
            <span className={styles.highlightLabel}>Category</span>
            <span className={styles.highlight}>{headline}</span>
          </div>
        </div>
      )}
      {totalLeads !== null && totalLeads > 10 && (
        <div className={styles.attribute}>
          <div className={styles.iconWrapper}>
            <ExpertProfileHighlightIcon glyph="CHAT" className={iconClass} />
          </div>
          <div className={styles.labels}>
            <span className={styles.highlightLabel}>Customers helped</span>
            <span className={styles.highlight}>{numeral(totalLeads).format('0,0')}</span>
          </div>
        </div>
      )}
      {highlights.map(highlight => (
        <React.Fragment key={highlight.type.id}>
          {highlight.value ? (
            <div className={styles.attribute}>
              <div className={styles.iconWrapper}>
                <ExpertProfileHighlightIcon glyph={highlight.type.icon} className={iconClass} />
              </div>
              <div className={styles.labels}>
                <span className={styles.highlightLabel}>{highlight.secondaryValue}</span>
                <span className={styles.highlight}>{highlight.value}</span>
              </div>
            </div>
          ) : null}
        </React.Fragment>
      ))}
    </div>
  )
}

export default Highlights
